// extracted by mini-css-extract-plugin
export default {"container":"styles_container__6W2GL","textWrapper":"styles_textWrapper__HTMpe","link":"styles_link__cz0Ei"};